import { Injectable } from '@angular/core';
import { ApiClientService } from '../../@core/services/api-client.service';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { HttpClient } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  public itemsInCart: number = 0;

  constructor(private apiClient: ApiClientService) { }

  getCart() {
    return this.apiClient.get(`${ApplicationRoutes.Payment.Cart.GetCart}`);
  }

  updateCart(body: any) {
    return this.apiClient.update(
      `${ApplicationRoutes.Payment.Cart.Update}`, body);
  }

  addToCart(body: any) {
    return this.apiClient.create(`${ApplicationRoutes.Payment.Cart.AddToCart}`, body);
  }

  removeFromCart(body: any) {
    return this.apiClient.update(
      `${ApplicationRoutes.Payment.Cart.RemoveFromCart}`, body);
  }

  validateCoupon(couponCode: string) {
    return this.apiClient.get(
      `${ApplicationRoutes.Payment.Coupon.ValidateCoupon}?couponCode=${couponCode}`);
  }

  createOrder(body: any) {
    return this.apiClient.create(
      `${ApplicationRoutes.Payment.Order.AddOrder}`, body);
  }

  getLocalCartItems() {
    return JSON.parse(localStorage.getItem('cartItems'));
  }

  async createPayment(userId: number, amount: string, courseId: number): Promise<string> {
    var request = await
      new Promise((resolve, reject) => {
        this.apiClient.postExternal('https://www.fncc.net/api/payment/pay/test',
          { amount: amount, udf1: `${userId}-course`, udf2: `https://portal.exab.sa/course/details/${courseId}` } as any)
          .subscribe({
            next: (result: any) => resolve(result?.url),
            // Reject instead of leaving the promise pending, so the checkout can leave its loading state.
            error: (error: any) => reject(error),
          });
      });

    return request ? request.toString() : '';
  }
}
